export default "__VITE_ASSET__BFiTf4mO__"